import React from 'react';
import propTypes from 'prop-types';
import Button from 'tailwind-components/Button';
import { STATE_LIST_CERT } from 'constants/enum';
import { sanitizeDirtyHTML } from 'helpers/strings';

// per-state certification instructions, plus the option to request only the
// non-SBE states (those that don't require certification)
export default function SBEInstructions({
  requestedStates,
  closeModal,
  handleSubmit
}) {
  const sbeRows = STATE_LIST_CERT.filter(row =>
    requestedStates.includes(row.state)
  );
  const nonSBEStates = requestedStates.filter(
    state => !sbeRows.some(row => row.state === state)
  );

  return (
    <>
      <div className='flex flex-col gap-4'>
        <div className='flex flex-col gap-2'>
          <p className='text-base font-semibold m-0'>
            Note: Once approved for each state, you must come back to the portal
            and request the appointments for that state.
          </p>
          {sbeRows.map(row => (
            <div key={row.state} className='mb-1'>
              <p className='text-base font-semibold m-0 mb-1'>{row.state}:</p>
              {row.instructions.map((instruction, index) => (
                <div
                  key={`${row.state}-${index}`}
                  dangerouslySetInnerHTML={sanitizeDirtyHTML(instruction || '')}
                />
              ))}
            </div>
          ))}
        </div>

        {nonSBEStates.length > 0 && (
          <>
            <hr className='border-grey-lightest m-0' />
            <div className='flex flex-col gap-2'>
              <p className='text-base font-semibold m-0'>
                Do you want to send the request for only the non-state based
                exchange requests?
              </p>
              {nonSBEStates.map(state => (
                <p key={state} className='m-0'>
                  - {state}
                </p>
              ))}
            </div>
          </>
        )}
      </div>

      <div className='flex flex-col-reverse lg:flex-row justify-end gap-3 mt-6 w-full'>
        <Button
          className='flex-1'
          variant='danger'
          text='Cancel and complete certification first'
          onClick={closeModal}
        />
        {nonSBEStates.length > 0 && (
          <Button
            className='flex-1'
            variant='primaryDarkened'
            text='Yes, request non-state based exchange states'
            onClick={() => handleSubmit(nonSBEStates, true)}
          />
        )}
      </div>
    </>
  );
}

SBEInstructions.propTypes = {
  requestedStates: propTypes.array.isRequired,
  closeModal: propTypes.func.isRequired,
  handleSubmit: propTypes.func.isRequired
};
